export default "__VITE_ASSET__DdBTsfmR__"